import React, { useState, useEffect } from "react";
import Header from "../../../components/header/Header";
import Footer from "../../../components/footer/Footer";
import { useNavigate, useParams } from "react-router-dom";
import { getChatPrescCompletion } from "../../../api/apiHandler";
import PatientInfoPop from "./PatientInfoPopup";
import DoctorInfoPopup from "./DoctorInfoPopup";
import QRCodePop from "../../doctor/prescription/QrCodePop/index.jsx";
import Swal from "sweetalert2";
import styled from "styled-components";
import moment from "moment";
import { EmailPrescriptionPopup } from "../../../modal/emailPrescriptionPopup/index.js";
import PriestMeetingRecord from "../../doctor/meeting-record/PriestMeetingRecord.js";
import NotesModal from "../../doctor/prescription/Notes/PrescriptionNotes.js";
import { TbInfoTriangle } from "react-icons/tb";

function PrescriptionPoc() {
  const params = useParams();
  console.log("paramssss", params);
  const navigate = useNavigate();
  const [prescriptionId, setPrescriptionId] = useState(params.id);
  const [medicineList, setMedicineList] = useState();
  console.log("medicineList12xs03s", medicineList);
  const [showPatiendInfo, setShowPatientInfo] = useState(false);
  const [typepres, settypepres] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [showDoctorInfo, setShowDoctorInfo] = useState(false);
  const [patientData, setPatientData] = useState(null);
  const [doctorData, setDoctorData] = useState(null);
  const [qrCodeUrl, setQrCodeUrl] = useState("");
  const [doctorDataDetails, setDoctorDataDetails] = useState(null);
  const [qrCode, setQrCode] = useState();
  const handlePatientInfo = () => setShowPatientInfo(!showPatiendInfo);
  const handleDoctorInfo = () => setShowDoctorInfo(!showDoctorInfo);
  const handleQRCode = () => setQrCode(!qrCode);
  const isOpenMailModal = (prescription) => {
    const userRole = localStorage.getItem("user_login_type_role");

    if (!userRole) {
      navigate("/");
      return;
    }

    setIsOpen(true);
  };
  useEffect(() => {
    if (prescriptionId) {
      Swal.fire({
        title: "Please wait...",
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const findPrescriptionObj = {
        id: prescriptionId,
      };

      getChatPrescCompletion(findPrescriptionObj).then((response) => {
        response = JSON.parse(response);
        Swal.close();
        if (response.code == process.env.REACT_APP_SUCCESS) {
          console.log("responsedata21", response.data);
          let patientData = JSON.parse(response.data.data.patientInfo);
          let doctorData = JSON.parse(response.data.data.doctorInfo);
          let medicineList = JSON.parse(response.data.data.precription);
          let qrurl = response.data.data.qrCode;
          console.log(patientData, "qrurlaa333sdasd");

          console.log(doctorData);
          setQrCodeUrl(qrurl);
          setMedicineList(medicineList);
          setPatientData(patientData);
          setDoctorData(doctorData);
        } else {
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: "error message", //response.message,
            toast: true,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      });
    }
  }, []);
  console.log(medicineList, "medicineList23eds21");
  const [openNotes, setOpenNotes] = useState(false);

  const handleViewNotes = () => {
    setOpenNotes(true);
  };

  return (
    <>
      <EmailPrescriptionPopup
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        medicineList={medicineList}
        doctorData={doctorData}
        patientData={patientData}
        paramsID={params}
      />
      <PatientInfoPop
        showPatiendInfo={showPatiendInfo}
        setShowPatientInfo={setShowPatientInfo}
        patientData={patientData}
      />
      <DoctorInfoPopup
        showDoctorInfo={showDoctorInfo}
        setShowDoctorInfo={setShowDoctorInfo}
        doctorData={doctorData}
      />
      <QRCodePop
        datePresc={moment().utc().format("D MMMM YYYY")}
        qrCodeUrl={qrCodeUrl}
        docData={doctorData}
        patientData={patientData}
        medicineList={medicineList}
        fromEmailMeetingId={medicineList?.[0]?.meeting_id}
        qrCode={qrCode}
        setQrCode={setQrCode}
      />
      <NotesModal show={openNotes} onClose={setOpenNotes} note={medicineList} />
      <main className="bg-color flex-column">
        <section className="doctorsec-pad share-medical">
          <div className="container">
            <div className="card">
              <div className="card-body doctor-table-card">
                <div className="d-flex justify-content-between align-center mb-2">
                  <button
                    className="px-3 py-2 rounded d-inline-flex align-items-center gap-2 bg-red-50 border border-red-200 shadow-sm hover:bg-red-100 transition-all"
                    onClick={handleViewNotes}
                    style={{ maxWidth: "max-content" }}
                  >
                    <TbInfoTriangle className="text-danger" size={20} />
                    <span className="fw-semibold text-red-700">Notes</span>
                  </button>
                </div>
                <>
                  <div className="table-responsive">
                    <table className="doctor-list-table table table-bordered">
                      <thead>
                        <tr>
                          <th scope="row">Page</th>
                          <th>Name of Drug</th>
                          <th>Strength</th>
                          <th>Strength Type</th>
                          <th>Unit</th>
                          <th>Form</th>
                          <th>Dose</th>
                          <th>Frequency</th>
                          <th>Intakes or Applications</th>
                          <th>Route</th>
                          <th>Refills</th>
                          <th>Quantity</th>
                          <th>Comments</th>
                        </tr>
                      </thead>
                      <tbody>
                        {medicineList &&
                          medicineList.map((item, index) => {
                            return (
                              <tr id={item.id} key={index}>
                                <td scope="row">{index + 1}</td>
                                <td>
                                  <h3 className="doc-details">
                                    {item.medicine_name}
                                  </h3>
                                </td>
                                <td>{item.strength}</td>
                                <td>{item.strength_type}</td>
                                <td>{item.units || item.unit}</td>
                                <td>{item.form || item.medicine_type}</td>
                                <td>{item.dose}</td>
                                <td>{item.frequency}</td>
                                <td>
                                  {item.intakes_applications || item.intake}
                                </td>
                                <td>{item.route}</td>
                                <td>{item.refills}</td>
                                <td>{item.quantity}</td>
                                <td>{item.comments}</td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  <PocPrescriptionWrpper className="d-flex mt-3 align-items-center justify-content-between flex-wrap gap-10">
                    <button
                      onClick={handleQRCode}
                      className="submit-btn d-inline-flex justify-content-center"
                      style={{ maxWidth: "max-content" }}
                    >
                      QR Codes
                    </button>
                    <button
                      onClick={handlePatientInfo}
                      className="submit-btn d-inline-flex justify-content-center"
                      style={{ maxWidth: "max-content" }}
                    >
                      Patient Info
                    </button>
                    <button
                      onClick={isOpenMailModal}
                      className={
                        medicineList?.length === 0
                          ? "submit-btn d-inline-flex justify-content-center disabled"
                          : "submit-btn d-inline-flex justify-content-center"
                      }
                      style={{
                        maxWidth: "max-content",
                      }}
                      disabled={medicineList?.length === 0}
                    >
                      Mail Prescription
                    </button>
                    <button
                      onClick={handleDoctorInfo}
                      className="submit-btn d-inline-flex  justify-content-center"
                      style={{ maxWidth: "max-content" }}
                    >
                      Doctor Info
                    </button>
                  </PocPrescriptionWrpper>
                </>
              </div>
            </div>
          </div>
        </section>
        {/* <Footer /> */}
      </main>
    </>
  );
}

const PocPrescriptionWrpper = styled.div`
  @media (max-width: 480px) {
    max-width: 300px;
    margin-left: auto;
    margin-right: auto;
    button {
      width: 100%;
      max-width: 100% !important;
    }
  }
`;

export default PrescriptionPoc;
